import { MESSAGES } from 'constants/Constants';
import ApiService from 'services/ApiService';

import { addNotification } from 'store/notificationModule/actions';
import { extractError } from 'utils/functions';
import { AppActions } from 'store/appModule/actions';
import { MultiUserActions } from 'store/multiUserModule/actions';
import { CONVERSION_TYPES, EVENT_LEVEL, EVENT_TYPES } from '../../components/Upsell/Constants';
import AnalyticsCore from '../../components/AnalyticsHandler/AnalyticsCore';

export const CLEAN_STATUS = 'CLEAN_STATUS';

const ACTION_PREFIX = 'onBoarding';

export const OnBoardingActionTypes = {
  FETCH_SUBSCRIPTIONS_WAITING: `${ACTION_PREFIX}/FETCH_SUBSCRIPTIONS_WAITING`,
  FETCH_SUBSCRIPTIONS_FAILED: `${ACTION_PREFIX}/FETCH_SUBSCRIPTIONS_FAILED`,
  FETCH_SUBSCRIPTION_COMPLETED: `${ACTION_PREFIX}/FETCH_SUBSCRIPTION_COMPLETED`,

  CREATE_SUBSCRIPTION_WAITING: `${ACTION_PREFIX}/CREATE_SUBSCRIPTION_WAITING`,
  CREATE_SUBSCRIPTION_FAILED: `${ACTION_PREFIX}/CREATE_SUBSCRIPTION_FAILED`,
  CREATE_SUBSCRIPTION_COMPLETED: `${ACTION_PREFIX}/CREATE_SUBSCRIPTION_COMPLETED`,

  CREATE_SEATS_WAITING: `${ACTION_PREFIX}/CREATE_SEATS_WAITING`,
  CREATE_SEATS_FAILED: `${ACTION_PREFIX}/CREATE_SEATS_FAILED`,
  CREATE_SEATS_COMPLETED: `${ACTION_PREFIX}/CREATE_SEATS_COMPLETED`,

  CREATE_ACCOUNT_WAITING: `${ACTION_PREFIX}/CREATE_ACCOUNT_WAITING`,
  CREATE_ACCOUNT_FAILED: `${ACTION_PREFIX}/CREATE_ACCOUNT_FAILED`,
  CREATE_ACCOUNT_COMPLETED: `${ACTION_PREFIX}/CREATE_ACCOUNT_COMPLETED`,

  UPDATE_ONBOARDING_USER: `${ACTION_PREFIX}/UPDATE_ONBOARDING_USER`,
  SUBSCRIPTION_PERIOD_CHANGE: `${ACTION_PREFIX}/SUBSCRIPTION_PERIOD_CHANGE`,
  SUBSCRIPTION_TYPE_CHANGE: `${ACTION_PREFIX}/SUBSCRIPTION_TYPE_CHANGE`,
  SUBSCRIPTION_RENEWAL_CHANGE: `${ACTION_PREFIX}/SUBSCRIPTION_RENEWAL_CHANGE`,
  SUBSCRIPTION_QUANTITY_CHANGE: `${ACTION_PREFIX}/SUBSCRIPTION_QUANTITY_CHANGE`,
  MODAL_SHOW_REQUEST_DEMO: `${ACTION_PREFIX}/MODAL_SHOW_REQUEST_DEMO`,
  MODAL_HIDE_REQUEST_DEMO: `${ACTION_PREFIX}/MODAL_HIDE_REQUEST_DEMO`,
  SEND_REQUEST_DEMO_WAITING: `${ACTION_PREFIX}/SEND_REQUEST_DEMO_WAITING`,
  SEND_REQUEST_DEMO_FAILED: `${ACTION_PREFIX}/SEND_REQUEST_DEMO_FAILED`,
  SEND_REQUEST_DEMO_COMPLETED: `${ACTION_PREFIX}/SEND_REQUEST_DEMO_COMPLETED`,

  FETCH_ORG_ADDRESS_TAX_RATE_REQUEST: `${ACTION_PREFIX}/FETCH_ORG_ADDRESS_TAX_RATE_REQUEST`,
  FETCH_ORG_ADDRESS_TAX_RATE_WAITING: `${ACTION_PREFIX}/FETCH_ORG_ADDRESS_TAX_RATE_WAITING`,
  FETCH_ORG_ADDRESS_TAX_RATE_FAILED: `${ACTION_PREFIX}/FETCH_ORG_ADDRESS_TAX_RATE_FAILED`,
  FETCH_ORG_ADDRESS_TAX_RATE_COMPLETED: `${ACTION_PREFIX}/FETCH_ORG_ADDRESS_TAX_RATE_COMPLETED`,

  FETCH_PRICE_REQUEST: `${ACTION_PREFIX}/FETCH_PRICE_REQUEST`,
  FETCH_PRICE_WAITING: `${ACTION_PREFIX}/FETCH_PRICE_WAITING`,
  FETCH_PRICE_FAILED: `${ACTION_PREFIX}/FETCH_PRICE_FAILED`,
  FETCH_PRICE_COMPLETED: `${ACTION_PREFIX}/FETCH_PRICE_COMPLETED`,

  FETCH_RENEWAL_PRICE_REQUEST: `${ACTION_PREFIX}/FETCH_RENEWAL_PRICE_REQUEST`,
  FETCH_RENEWAL_PRICE_WAITING: `${ACTION_PREFIX}/FETCH_RENEWAL_PRICE_WAITING`,
  FETCH_RENEWAL_PRICE_FAILED: `${ACTION_PREFIX}/FETCH_RENEWAL_PRICE_FAILED`,
  FETCH_RENEWAL_PRICE_COMPLETED: `${ACTION_PREFIX}/FETCH_RENEWAL_PRICE_COMPLETED`,

  UPDATE_ORG_FORM_ADDRESS: `${ACTION_PREFIX}/UPDATE_ORG_FORM_ADDRESS`,
};

export function fetchOrgAddressTaxRate(orgAddress, amount, organizationId, step) {
  return {
    type: OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_REQUEST,
    payload: {
      orgAddress,
      amount,
      organizationId,
      step,
    },
  };
}

export function fetchOrgAddressTaxRateInProgress() {
  return {
    type: OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_WAITING,
  };
}

export function fetchOrgAddressTaxRateFailed() {
  return {
    type: OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_FAILED,
    payload: {},
  };
}

export function fetchOrgAddressTaxRateCompleted(taxDetails) {
  return {
    type: OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_COMPLETED,
    payload: {
      taxDetails,
    },
  };
}

export function fetchPrice(seats, months) {
  return {
    type: OnBoardingActionTypes.FETCH_PRICE_REQUEST,
    payload: {
      seats,
      months,
    },
  };
}

export function fetchPriceInProgress() {
  return {
    type: OnBoardingActionTypes.FETCH_PRICE_WAITING,
  };
}

export function fetchPriceFailed() {
  return {
    type: OnBoardingActionTypes.FETCH_PRICE_FAILED,
    payload: {},
  };
}

export function fetchPriceCompleted(priceDetails) {
  return {
    type: OnBoardingActionTypes.FETCH_PRICE_COMPLETED,
    payload: {
      priceDetails,
    },
  };
}

export function fetchRenewalPrice(seats) {
  return {
    type: OnBoardingActionTypes.FETCH_RENEWAL_PRICE_REQUEST,
    payload: {
      seats,
    },
  };
}

export function fetchRenewalPriceInProgress() {
  return {
    type: OnBoardingActionTypes.FETCH_RENEWAL_PRICE_WAITING,
  };
}

export function fetchRenewalPriceFailed() {
  return {
    type: OnBoardingActionTypes.FETCH_RENEWAL_PRICE_FAILED,
    payload: {},
  };
}

export function fetchRenewalPriceCompleted(priceDetails) {
  return {
    type: OnBoardingActionTypes.FETCH_RENEWAL_PRICE_COMPLETED,
    payload: {
      priceDetails,
    },
  };
}

export function fetchSubscriptionsInProgress() {
  return {
    type: OnBoardingActionTypes.FETCH_SUBSCRIPTIONS_WAITING,
    payload: {
      status: MESSAGES.CREATE_SUBSCRIPTION_WAITING,
    },
  };
}

export function fetchSubscriptionsFailed(msgError) {
  return {
    type: OnBoardingActionTypes.FETCH_SUBSCRIPTIONS_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_SUBSCRIPTION_FAILED,
    },
  };
}

export function fetchSubscriptionsCompleted(subscriptions) {
  return {
    type: OnBoardingActionTypes.FETCH_SUBSCRIPTION_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function createSubscriptionInProgress() {
  return {
    type: OnBoardingActionTypes.CREATE_SUBSCRIPTION_WAITING,
    payload: {
      status: MESSAGES.CREATE_SUBSCRIPTION_WAITING,
    },
  };
}

export function createSubscriptionFailed(msgError) {
  return {
    type: OnBoardingActionTypes.CREATE_SUBSCRIPTION_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_SUBSCRIPTION_FAILED,
    },
  };
}

export function createSubscriptionCompleted(subscriptions) {
  return {
    type: OnBoardingActionTypes.CREATE_SUBSCRIPTION_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function createSeatsInProgress() {
  return {
    type: OnBoardingActionTypes.CREATE_SEATS_WAITING,
    payload: {
      status: MESSAGES.CREATE_SEATS_WAITING,
    },
  };
}

export function createSeatsFailed(msgError) {
  return {
    type: OnBoardingActionTypes.CREATE_SEATS_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_SEATS_FAILED,
    },
  };
}

export function createSeatsCompleted(seats, isUpgrading = false) {
  return {
    type: OnBoardingActionTypes.CREATE_SEATS_COMPLETED,
    payload: {
      seats,
      isUpgrading,
    },
  };
}

export function createAccountInProgress() {
  return {
    type: OnBoardingActionTypes.CREATE_ACCOUNT_WAITING,
    payload: {
      status: MESSAGES.CREATE_ACCOUNT_WAITING,
    },
  };
}

export function createAccountFailed(msgError) {
  return {
    type: OnBoardingActionTypes.CREATE_ACCOUNT_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_ACCOUNT_FAILED,
    },
  };
}

export function createAccountCompleted(onboardingUser) {
  return {
    type: OnBoardingActionTypes.CREATE_ACCOUNT_COMPLETED,
    payload: {
      onboardingUser,
    },
  };
}

export function updateOnboardingUser(onboardingUser) {
  return {
    type: OnBoardingActionTypes.UPDATE_ONBOARDING_USER,
    payload: {
      onboardingUser,
    },
  };
}

export function subscriptionTypeChange(subscriptionType) {
  return {
    type: OnBoardingActionTypes.SUBSCRIPTION_TYPE_CHANGE,
    payload: {
      subscriptionType,
    },
  };
}

export function subscriptionPeriodChange(subscriptionPeriod) {
  return {
    type: OnBoardingActionTypes.SUBSCRIPTION_PERIOD_CHANGE,
    payload: {
      subscriptionPeriod,
    },
  };
}

export function subscriptionRenewalChange(subscriptionRenewal) {
  return {
    type: OnBoardingActionTypes.SUBSCRIPTION_RENEWAL_CHANGE,
    payload: {
      subscriptionRenewal,
    },
  };
}

export function subscriptionQuantityChange(subscriptionQuantity) {
  return {
    type: OnBoardingActionTypes.SUBSCRIPTION_QUANTITY_CHANGE,
    payload: {
      subscriptionQuantity,
    },
  };
}

export function showRequestDemo() {
  return {
    type: OnBoardingActionTypes.MODAL_SHOW_REQUEST_DEMO,
  };
}

export function hideRequestDemo() {
  return {
    type: OnBoardingActionTypes.MODAL_HIDE_REQUEST_DEMO,
  };
}

export function sendDemoRequestInProgress() {
  return {
    type: OnBoardingActionTypes.SEND_REQUEST_DEMO_WAITING,
    payload: {
      status: MESSAGES.DEMO_REQUEST_WAITING,
    },
  };
}

export function sendDemoRequestFailed(msgError) {
  return {
    type: OnBoardingActionTypes.SEND_REQUEST_DEMO_FAILED,
    payload: {
      status: msgError || MESSAGES.DEMO_REQUEST_FAILED,
    },
  };
}

export function sendDemoRequestCompleted() {
  return {
    type: OnBoardingActionTypes.SEND_REQUEST_DEMO_COMPLETED,
  };
}

export function updateOrgFormAddress(country, stateVal, city, address, postalCode) {
  return {
    type: OnBoardingActionTypes.UPDATE_ORG_FORM_ADDRESS,
    payload: {
      country,
      stateVal,
      city,
      address,
      postalCode,
    },
  };
}

export const OnBoardingActions = {
  fetchSubscriptionsInProgress,
  fetchSubscriptionsFailed,
  fetchSubscriptionsCompleted,
  createSubscriptionInProgress,
  createSubscriptionFailed,
  createSubscriptionCompleted,
  createAccountInProgress,
  createAccountFailed,
  createAccountCompleted,
  updateOnboardingUser,
  subscriptionTypeChange,
  subscriptionRenewalChange,
  subscriptionQuantityChange,
  subscriptionPeriodChange,
  showRequestDemo,
  hideRequestDemo,
  sendDemoRequestInProgress,
  sendDemoRequestFailed,
  sendDemoRequestCompleted,
  fetchSubscriptions,
  createSubscription,
  createSeats,
  createSubscriptionWithCreditCard,
  createSeatsWithCreditCard,
  createAccount,
  sendDemoRequest,
  fetchOrgAddressTaxRate,
  fetchPrice,
  updateOrgFormAddress,
};

/**
|--------------------------------------------------
| Async Actions
|--------------------------------------------------
*/

export function fetchSubscriptions() {
  return (dispatch, getStore) => {
    if (getStore().app.isFetchingSubscriptions) {
      return undefined;
    }

    dispatch(fetchSubscriptionsInProgress());
    return ApiService.fetchSubscriptions().then(
      res => {
        dispatch(fetchSubscriptionsCompleted(res.data));
      },
      err => {
        const error = err.response;
        dispatch(fetchSubscriptionsFailed(extractError(error.data)));
      },
    );
  };
}

export function createSubscription(subscriptionType, subscriptionRenewal, subscriptionQuantity = 1) {
  return dispatch => {
    dispatch(createSubscriptionInProgress());
    ApiService.createSubscription({
      type: subscriptionType,
      period: subscriptionRenewal,
      quantity: subscriptionQuantity,
    }).then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_SUBSCRIPTION_SUCCESS));
        ApiService.track({
          uuid: null,
          action: null,
          event: EVENT_TYPES.CONVERSION,
          level: EVENT_LEVEL.SUCCESS,
          name: CONVERSION_TYPES.PURCHASE,
        });
        if (subscriptionQuantity === 1) {
          dispatch(createSubscriptionCompleted([res.data]));
        } else {
          dispatch(createSubscriptionCompleted(res.data));
          dispatch(MultiUserActions.updatePurchasedSubscription(subscriptionType, subscriptionRenewal));
        }
      },
      err => {
        const error = err.response;
        dispatch(createSubscriptionFailed(extractError(error.data)));
      },
    );
  };
}

export function createSeats(seatsNumber, months, isUpgrading, eventData = null) {
  return dispatch => {
    dispatch(createSeatsInProgress());
    const api = isUpgrading
      ? ApiService.addSeats({
          quantity: seatsNumber,
        })
      : ApiService.createSeats({
          quantity: seatsNumber,
          months,
          mode: isUpgrading ? 'upgrade' : null,
        });

    api.then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_SEATS_SUCCESS));
        if (seatsNumber === 1) {
          dispatch(createSeatsCompleted(isUpgrading ? res.data : [res.data], isUpgrading));
        } else {
          dispatch(createSeatsCompleted(res.data, isUpgrading));
          dispatch(MultiUserActions.updatePurchasedSeats(seatsNumber, months));
        }

        if (eventData) {
          const specificEventData = { ...eventData };
          specificEventData.eventName = `${eventData.eventName}_COMPLETED`;
          AnalyticsCore.sendEvent(specificEventData);
        }
      },
      err => {
        const error = err.response;
        dispatch(createSeatsFailed(extractError(error.data)));

        if (eventData) {
          const specificEventData = { ...eventData };
          specificEventData.eventName = `${eventData.eventName}_FAILED`;
          specificEventData.eventLabel = extractError(error.data);
          AnalyticsCore.sendEvent(specificEventData);
        }
      },
    );
  };
}

export function addSeats(seatsNumber) {
  return dispatch => {
    dispatch(createSeatsInProgress());
    ApiService.addSeats({
      quantity: seatsNumber,
    }).then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_SEATS_SUCCESS));
        if (seatsNumber === 1) {
          dispatch(createSeatsCompleted([res.data]));
        } else {
          dispatch(createSeatsCompleted(res.data));
          dispatch(MultiUserActions.updatePurchasedSeats(seatsNumber));
        }
      },
      err => {
        const error = err.response;
        dispatch(createSeatsFailed(extractError(error.data)));
      },
    );
  };
}
export function createSubscriptionWithCreditCard(
  token,
  card,
  subscriptionType,
  subscriptionRenewal,
  subscriptionQuantity = 1,
) {
  return dispatch => {
    dispatch(AppActions.createPaymentInProgress());
    ApiService.createCreditCardWithSubscription({
      token,
      card,
      type: subscriptionType,
      period: subscriptionRenewal,
      quantity: subscriptionQuantity,
    }).then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_PAYMENT_SUCCESS));
        dispatch(AppActions.createPaymentCompleted(res.data.payment_method));
        dispatch(MultiUserActions.updatePurchasedSubscription(subscriptionType, subscriptionRenewal));
        dispatch(createSubscriptionCompleted(res.data.subscriptions));
        ApiService.track({
          uuid: null,
          action: null,
          event: EVENT_TYPES.CONVERSION,
          level: EVENT_LEVEL.SUCCESS,
          name: CONVERSION_TYPES.PURCHASE,
        });
      },
      err => {
        const error = err.response;
        if (error.data && error.data.payment_method) {
          dispatch(AppActions.createPaymentCompleted(error.data.payment_method));
          dispatch(createSubscriptionFailed());
        } else {
          dispatch(AppActions.createPaymentFailed(extractError(error.data)));
        }
      },
    );
  };
}

export function createSeatsWithCreditCard(
  token,
  card,
  subscriptionQuantity,
  subscriptionPeriod,
  isUpgrading,
  eventData = null,
) {
  return dispatch => {
    dispatch(AppActions.createPaymentInProgress());

    if (isUpgrading) {
      ApiService.createCreditCardWithUpgradeSeats({
        token,
        card,
        quantity: subscriptionQuantity,
        months: subscriptionPeriod,
      }).then(
        res => {
          dispatch(addNotification(MESSAGES.CREATE_PAYMENT_SUCCESS));
          dispatch(AppActions.createPaymentCompleted(res.data.payment_method));
          dispatch(MultiUserActions.updatePurchasedSeats(subscriptionQuantity, subscriptionPeriod));
          dispatch(createSeatsCompleted(res.data.seats));
          if (eventData) {
            const specificEventData = { ...eventData };
            specificEventData.eventName = `${eventData.eventName}_COMPLETED`;
            AnalyticsCore.sendEvent(specificEventData);
          }

          ApiService.track({
            uuid: null,
            action: null,
            event: EVENT_TYPES.CONVERSION,
            level: EVENT_LEVEL.SUCCESS,
            name: CONVERSION_TYPES.PURCHASE,
          });
        },
        err => {
          const error = err.response;
          if (eventData) {
            const specificEventData = { ...eventData };
            specificEventData.eventName = `${eventData.eventName}_FAILED`;
            specificEventData.eventLabel =
              error.data && error.data.payment_method ? error.data.payment_method : extractError(error.data);
            AnalyticsCore.sendEvent(specificEventData);
          }

          if (error.data && error.data.payment_method) {
            dispatch(AppActions.createPaymentCompleted(error.data.payment_method));
            dispatch(createSeatsFailed());
          } else {
            dispatch(AppActions.createPaymentFailed(extractError(error.data)));
          }
        },
      );
    } else {
      ApiService.createCreditCardWithSeats({
        token,
        card,
        quantity: subscriptionQuantity,
        months: subscriptionPeriod,
      }).then(
        res => {
          dispatch(addNotification(MESSAGES.CREATE_PAYMENT_SUCCESS));
          dispatch(AppActions.createPaymentCompleted(res.data.payment_method));
          dispatch(MultiUserActions.updatePurchasedSeats(subscriptionQuantity, subscriptionPeriod));
          dispatch(createSeatsCompleted(res.data.seats));

          if (eventData) {
            const specificEventData = { ...eventData };
            specificEventData.eventName = `${eventData.eventName}_COMPLETED`;
            AnalyticsCore.sendEvent(specificEventData);
          }

          ApiService.track({
            uuid: null,
            action: null,
            event: EVENT_TYPES.CONVERSION,
            level: EVENT_LEVEL.SUCCESS,
            name: CONVERSION_TYPES.PURCHASE,
          });
        },
        err => {
          const error = err.response;

          if (eventData) {
            const specificEventData = { ...eventData };
            specificEventData.eventName = `${eventData.eventName}_FAILED`;
            specificEventData.eventLabel =
              error.data && error.data.payment_method ? error.data.payment_method : extractError(error.data);
            AnalyticsCore.sendEvent(specificEventData);
          }
          if (error.data && error.data.payment_method) {
            dispatch(AppActions.createPaymentCompleted(error.data.payment_method));
            dispatch(createSeatsFailed());
          } else {
            dispatch(AppActions.createPaymentFailed(extractError(error.data)));
          }
        },
      );
    }
  };
}

export function createAccount(email, password, firstName, lastName, recaptcha) {
  return dispatch => {
    dispatch(createAccountInProgress());
    return ApiService.createAccount({ email, password, firstName, lastName, recaptcha }).then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_ACCOUNT_SUCCESS));
        dispatch(createAccountCompleted(res.data));
        ApiService.track({
          uuid: null,
          action: null,
          event: EVENT_TYPES.CONVERSION,
          level: EVENT_LEVEL.SUCCESS,
          name: CONVERSION_TYPES.SIGNUP,
        });
      },
      err => {
        const error = err.response;
        dispatch(createAccountFailed(extractError(error.data)));
      },
    );
  };
}

export function sendDemoRequest(
  fullName,
  email,
  companyName,
  jobTitle,
  phoneNumber,
  recaptcha,
  decisionMaker,
  decisionMakerEmail,
  decisionMakerJob,
) {
  return dispatch => {
    dispatch(sendDemoRequestInProgress());
    return ApiService.sendDemoRequest({
      email,
      recaptcha,
      full_name: fullName,
      company_name: companyName,
      job_title: jobTitle,
      phone_number: phoneNumber,
      decision_maker: decisionMaker,
      decision_maker_email: decisionMakerEmail,
      decision_maker_job: decisionMakerJob,
    }).then(
      res => {
        dispatch(sendDemoRequestCompleted(res.data));
        ApiService.track({
          uuid: null,
          action: null,
          event: EVENT_TYPES.CONVERSION,
          level: EVENT_LEVEL.SUCCESS,
          name: CONVERSION_TYPES.DEMO_REQUEST,
        });
      },
      err => {
        const error = err.response;
        dispatch(sendDemoRequestFailed(extractError(error.data)));
      },
    );
  };
}
